import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import SmsTemplateForm from "./components/SmsTemplateForm";

import { useAddSmsTemplateMutation } from "store/services/smsTemplateApi";

const SmsTemplateCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "SMS Templates", path: "/app/crm/sms-templates/list" },
    { title: "New SMS Template" },
  ];

  // RTK Query hook for adding a new SMS template
  const [addSmsTemplate, { isLoading }] = useAddSmsTemplateMutation();

  const handleCreateSmsTemplate = async (data) => {
    try {
      const { _id } = await addSmsTemplate(data).unwrap();
      toast.success("SMS Template successfully created!");
      navigate(`/app/crm/sms-templates/${_id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create SMS Template!"
      );
    }
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isLoading}>
      <BreadcrumbLayout.Paper>
        <SmsTemplateForm
          isBusy={isLoading}
          onSubmit={handleCreateSmsTemplate}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default SmsTemplateCreateScreen;